module.exports = __webpack_public_path__ + "static/img/success_logo.7178af58.png";